import { app } from 'apprun';
import { getAgentLink } from './utility';
import { lang } from './Txlat';

export default function ({ agent1, agent2 }) {
  return <>
    {agent1 && agent1.name ? < div class="d-flex ">
      <div class="agent-image">
        {
          agent1.isCommercailAgent ?
            <a target={'agent' + agent1.id} style="cursor: pointer;" href={getAgentLink(agent1)}><img class="rounded" src={agent1.photo_path ? agent1.photo_path : '/images/missing-agent.jpg'} width="100" alt="" /></a>
            :
            <img class="rounded" src={agent1.photo_path ? agent1.photo_path : '/images/missing-agent.jpg'} width="100" alt="" />
        }
      </div>
      <ul class="agent-information list-unstyled">
        <li class="agent-name">
          {
            agent1.isCommercailAgent ? <a target={'agent' + agent1.id} style="cursor: pointer;" href={getAgentLink(agent1)}><b>{agent1.name}</b></a>
              : <b>{agent1.name}</b>
          }
        </li>
        <li class="agent-name">{lang.get() === 'en' ? agent1.title : agent1.title_FR}</li>
        <li class="agent-name">{agent1.officeName}</li>
        <li class="agent-name mr-3">{agent1.phone}</li>
      </ul>
    </div> : ''
    }

    {agent2 && agent2.name ?
      <div>
        <br></br>
        <div class="d-flex ">
          <div class="agent-image">
            {
              agent2.isCommercailAgent ?
                <a target={'agent' + agent2.id} href={getAgentLink(agent2)}><img class="rounded" src={agent2.photo_path ? agent2.photo_path : '/images/missing-agent.jpg'} width="100" alt="" /></a>
                :
                <img class="rounded" src={agent2.photo_path ? agent2.photo_path : '/images/missing-agent.jpg'} width="100" alt="" />
            }

          </div>
          <ul class="agent-information list-unstyled">
            <li class="agent-name">
              {
                agent2.isCommercailAgent ?
                  <a target={'agent' + agent2.id} href={getAgentLink(agent2)}><b>{agent2.name}</b></a>
                  :
                  <b>{agent2.name}</b>
              }
            </li>
            <li class="agent-name">{lang.get() === 'en' ? agent2.title : agent2.title_FR}</li>
            <li class="agent-name">{agent2.officeName}</li>
            <li class="agent-name mr-3">{agent2.phone}</li>
          </ul>
        </div>
      </div>
      : ''
    }

  </>;
}
